export const BLUE = 'blue';
export const BROWN = 'brown';
export const GRAY = 'gray';
export const GREEN = 'green';
export const PURPLE = 'purple';
export const RED = 'red';
export const TEAL = 'teal';
export const DEBUGGER = 'debugger';